function moveBanners(grid = 1, productGrid = null) {
    const bannerSection = document.querySelector('.plp-insert-banner-section');
    const targetProductGrid = productGrid || document.querySelector('.collection-listing .product-grid');

    if (!bannerSection || !targetProductGrid) return;

    const range = parseInt(bannerSection.getAttribute('data-range'), 10);
    const banners = bannerSection.querySelectorAll('.mobile-banner.mb-shuffle');

    // The product grid is replaced during AJAX filtering and sorting. Remove
    // old clones before inserting the current set again.
    targetProductGrid.querySelectorAll('[data-plp-banner-instance]').forEach((banner) => banner.remove());

    const insertBanner = (banner, targetIndex, instanceIndex) => {
        const targetProductBlock = targetProductGrid.querySelector(`product-block[data-index="${targetIndex}"]`);

        if (!targetProductBlock) return false;

        const bannerClone = banner.cloneNode(true);
        bannerClone.removeAttribute('hidden');
        bannerClone.dataset.plpBannerInstance = instanceIndex;
        bannerClone.style.setProperty('--grid-span-mb', `span ${grid}`);
        targetProductBlock.insertAdjacentElement('afterend', bannerClone);
        return true;
    };

    if (banners.length === 1) {
        // A single banner repeats after every configured number of products.
        let targetIndex = range;
        let instanceIndex = 0;
        while (insertBanner(banners[0], targetIndex, instanceIndex)) {
            targetIndex += range;
            instanceIndex += 1;
        }
    } else {
        // Multiple banners are inserted once each, in their configured order.
        banners.forEach((banner, index) => {
            insertBanner(banner, range * (index + 1), index);
        });
    }
}

document.addEventListener('collection:filters-refreshed', (event) => {
    const root = event.detail && event.detail.root;
    const productGrid = root && root.querySelector('.collection-listing .product-grid');
    if (productGrid) {
        const grid = productGrid.classList.contains('product-grid--per-row-mob-1') ? 1 : 2;
        moveBanners(grid, productGrid);
    }
});

document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.querySelector('.plp-insert-banner-section')) return;

    const productGrid = document.querySelector('.collection-listing .product-grid');
    if (productGrid) {
        const grid = productGrid.classList.contains('product-grid--per-row-mob-1') ? 1 : 2;
        moveBanners(grid, productGrid);
    }
});
